(ns portal.agency-configuration-page.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :page.agency-configuration/init
  [(rf/inject-cofx :query-params)]
  (fn [{:keys [query-params]}]
    (let [redirected-adserver-id (:adserver-account-id query-params)]
      {:fx [(when redirected-adserver-id
              [:dispatch [:form.adserver/load-adserver redirected-adserver-id]])]})))
